import React, { forwardRef } from 'react';
import { Link as RouterLink, LinkProps, To } from 'react-router-dom';
import { Link as MUILink, LinkProps as MUILinkProps } from '@mui/material';

export const LinkComponent = forwardRef<
  HTMLAnchorElement,
  LinkProps & { href?: To }
>(({ href, ...props }, ref) => (
  // eslint-disable-next-line react/prop-types
  <RouterLink {...props} to={href || props.to} ref={ref} />
));

LinkComponent.displayName = 'LinkComponent';

export const Link = forwardRef<
  HTMLAnchorElement,
  { to: To } & Omit<MUILinkProps, 'href'>
>(function Link(props, ref) {
  return <MUILink {...props} component={RouterLink} ref={ref} />;
});
